import React from 'react';
import { DIVISION_COLORS } from '../utils/constants';

export default function DivisionBadge({ division, className = '' }) {
  const c = DIVISION_COLORS[division] || {
    bg: 'bg-gray-100', border: 'border-gray-200', text: 'text-gray-700', dot: 'bg-gray-400',
  };
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs font-medium ${c.bg} ${c.border} ${c.text} ${className}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${c.dot}`} />
      {division}
    </span>
  );
}
